export default __webpack_public_path__ + "47ab36635918fb60d40e48a1cdc42c76.png";